<template>
	<div class="vertical analysis" @click="removeFilter">
		<el-row class="answer" 
			type="flex"
			v-for="answer in filteredQuestion.answer"
			:key="answer.key">
			<el-col class="answer-check" :span="1">
				<el-checkbox @change="openPatientList(answer.user, question.id, answer.key)"
					v-model="checkValues[answer.key]"></el-checkbox>
			</el-col>
			<el-col class="answer-option" :span="6">
				<div :class="['option', { unanswered: answer.name == 'unanswered'}]">{{ answer.name == 'unanswered' ? 'Not Answered' : answer.name }}</div>
			</el-col>
			<el-col :span="16" class="bar-holder" >
				<div v-if="!isNaN(answer.user.length) && !isNaN(question.event.other)"
					@click="openPatientList(answer.user, question.id, answer.key, true)">
					<div class="percentage">
					<Bar class="bar"
						type="vertical"
						:value="answer.user.length" 
						:total="question.event.other" 
						:color="color[0]" />
					</div>
					<div class="response">
						{{ formatCount(answer.user.length, 'response') }}
					</div>
					<FlagIcon class="flag-icon" v-if="hasProblem(answer.user)"></FlagIcon>
				</div>
				
			</el-col>
		</el-row>
		
	</div>
</template>
<script>
import OutcomeAnalysis from '.'
import question from '../../question'
import Bar from './Bar'
import FlagIcon from '@/module/population/list/icon/Flag.vue'

export default {
	name: 'outcome-question-vertical-analysis',
	extends: OutcomeAnalysis,


	props: {
		contain: {
			type: String,
			default: ''
		},
		minValue: [Number, String],
		maxValue: [Number, String]
	},

	computed: {
		filteredQuestion() {
			try {
				if(this.contain === '' && !this.notEmpty(this.minValue) && !this.notEmpty(this.maxValue))
					return this.question
				return  {
					...this.question,
					answer: this.question.answer.map((ans) => ({
						...ans,
						user: ans.user.filter(({value}) => {
							const name = ans.name
							if(this.contain !== '') {
								if(name !== 'unanswered' && value) {
									const containCase = this.contain.toLowerCase()
									if(Array.isArray(value) && value.length == 1)
										return value[0].value && value[0].value.toLowerCase().includes(containCase)
									else if(Array.isArray(value.answer) && value.answer.length == 1)
										return value.answer[0] && value.answer[0].answer && value.answer[0].answer.toLowerCase().includes(containCase)
								}
							}
							if(this.notEmpty(this.minValue) || this.notEmpty(this.maxValue)) {
								if(name !== 'unanswered' && value) {
									if(Array.isArray(value) && value.length == 1) {
										const formattedVal = this.formatValue(value[0], this.question.type)
										const isMin = this.notEmpty(this.minValue) ? (formattedVal >= this.minValue) : true,
											isMax = this.notEmpty(this.maxValue) ? (formattedVal <= this.maxValue) : true
										console.log(this.minValue, formattedVal, isMin)
										return formattedVal && isMin && isMax
									}
								}
								return false
							}
							return true
						})
					}))
				}
			} catch (error) {
				console.error('Problem calculating filteredQuestion ', error)
				return this.question
			}
			
			
			return this.question
		}
	},

	methods: {
		formatValue(value, type) {
			if(type === 'unit' && value.answer)
				return parseFloat(value.answer)
			if(type === 'date' && value.year)
				return Date.parse(`${value.year}-${value.month}-${value.date || '01'}`)
			return null
		},
		notEmpty(value) {
			return value !== undefined && value !== null && value !== ''
		},
		hasProblem(eventList) {
			if(eventList.flatMap(({problem}) => problem ? problem.filter(({question_id}) => question_id === this.question.id) : []).length > 0)
				return true
			return false
		}
	},

	components: {
		Bar,
		FlagIcon
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
